$(document).ready(function () {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');

  createBurgerIcon();
  customSearchBar();
});

// --------------------------------
// Custom burger menu
function createBurgerIcon() {
  $.each(new Array(3), function () {
    $('.header .mobile-nav-toggle').append('<span class="burger-line"></span>');
  });
}

// Searchbox scripts
function customSearchBar() {
  let searchPlaceholder = 'Search Website';

  $('.header .searchBox input').val('');
  $('.header .searchBox input').attr('placeholder', searchPlaceholder);
}

// function to validate external Links
export function isLocalUrl(urlToCheck) {
  const clientPath = SITEBASEURL;
  return urlToCheck !== null && urlToCheck.includes(clientPath);
}

export function validateWindowSize(breakpointValue) {
  const breakpoint = breakpointValue;
  return $(window).width() >= breakpoint;
}
